import { render, staticRenderFns } from "./GClassManagementGroupingProposal.vue?vue&type=template&id=326f727b&scoped=true&"
import script from "./GClassManagementGroupingProposal.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupingProposal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f727b",
  null
  
)

export default component.exports